import Model from "@tripian/model";

/**
 * tour-api'nin ürün toplayıcısında (peeperall enhanced_tour_api_product_collector)
 * ve availability mapper'larında karşılığı olmayan provider'lar. Bunların ürünleri
 * tour-api search'ten hiç dönmüyor; white label'da böyle bir provider açıksa tourApi
 * moduna geçmek o provider'ın tüm ürünlerini listeden sessizce siler (filtrede adı
 * görünür, seçilince liste boş gelir). Backend bu provider'ları eklediğinde buradan
 * çıkarılmalı.
 */
const TOUR_API_UNSUPPORTED_PROVIDER_IDS: Model.PROVIDER_ID[] = [
  Model.PROVIDER_ID.BOOK_BARBADOS,
  Model.PROVIDER_ID.REZDY,
  Model.PROVIDER_ID.LIVN,
];

/**
 * Tur/bilet verisinin kaynağını seçer:
 * - true  → tek bir POST /tour-api/search akışı (tüm provider'lar backend'de birleşik)
 * - false → her provider'ın kendi katalog API'si (legacy hook'lar)
 *
 * tourApi, desteklenmeyen provider'ı olmayan tüm white label'larda açık. Kontrolü tek
 * dosyada tutuyoruz ki backend bunun için bir config bayrağı verdiğinde (ör.
 * whiteLabels.tourApiEnabled) yalnızca burası değişsin, çağrı noktaları değişmesin.
 *
 * window.tconfig.TOUR_TICKET_PROVIDER_IDS setConfigList() içinde dolduruluyor ve
 * uygulama yalnızca init bittikten sonra render ediliyor; bu yüzden render anında
 * okumak güvenli.
 */
const isTourApiEnabled = (): boolean => {
  const providerIds = window.tconfig?.TOUR_TICKET_PROVIDER_IDS || [];
  return !providerIds.some(id => TOUR_API_UNSUPPORTED_PROVIDER_IDS.includes(id));
};

export default isTourApiEnabled;
